(function () {
  document.addEventListener('DOMContentLoaded', () => {
    const scripts = document.querySelectorAll('script[src*="skullhead-gallery.js"]');
    scripts.forEach((scriptEl) => initGallerySection(scriptEl));
  });

  function initGallerySection(scriptEl) {
    const sectionId = scriptEl.dataset.section;
    const sectionContainer = document.getElementById(sectionId);
    const rawSlogansText = scriptEl.dataset.slogans;
    const sloganHeading = sectionContainer.querySelector('.slogan');
    const galleryContainer = sectionContainer.querySelector('.gallery__items');
    const imageElements = Array.from(sectionContainer.querySelectorAll('.gallery__item'));

    let currentSlogan = -1;
    let breakpoints, slogansArray;

    /**
     * Main execution thread
     *
     * @returns {void}
     */
    function init() {
      slogansArray = getSlogansArray(rawSlogansText);
      breakpoints = computeBreakpoints(galleryContainer.getBoundingClientRect().height, slogansArray.length, 0.1, 0.83);

      updateActiveSlogan();
      setListeners();
      initIntersectionObserverForImgs();
    }

    /**
     * Reformat raw slogans into array
     *
     * @param rawText
     * @returns {*[]}
     */
    function getSlogansArray(rawText) {
      return (rawText.match(/'([^']*)'/g) || []).map((quoted) => quoted.slice(1, -1));
    }

    /**
     * Compute evenly‑spaced breakpoints between two fractions of a height.
     *
     * @param {number} containerHeight
     * @param {number} numberOfPoints
     * @param {number} startRatio
     * @param {number} endRatio
     * @returns {number[]}
     */
    function computeBreakpoints(containerHeight, numberOfPoints, startRatio, endRatio) {
      const startOffsetPx = containerHeight * startRatio;
      const usableSpanPx = containerHeight * (endRatio - startRatio);

      return Array.from({ length: numberOfPoints }, (_, index) => {
        const fraction = numberOfPoints === 1 ? 0.5 : index / (numberOfPoints - 1);
        return Math.round(startOffsetPx + usableSpanPx * fraction);
      });
    }

    /**
     * Updates the currently displayed slogan based on the user's scroll position.
     *
     * @returns {void}
     */
    function updateActiveSlogan() {
      const scrollY = window.pageYOffset;
      const viewportMid = scrollY + window.innerHeight / 2;
      const galleryRect = galleryContainer.getBoundingClientRect();
      const galleryTopY = scrollY + galleryRect.top;
      const galleryBottomY = scrollY + galleryRect.bottom;

      if (viewportMid < galleryTopY || viewportMid > galleryBottomY) {
        if (currentSlogan !== -1) {
          currentSlogan = -1;
          sloganHeading.classList.remove('visible');
        }
        return;
      }

      let newActiveIndex = -1;

      breakpoints.forEach((bpOffset, i) => {
        if (viewportMid >= galleryTopY + bpOffset) {
          newActiveIndex = i;
        }
      });

      if (newActiveIndex === currentSlogan) return;

      currentSlogan = newActiveIndex;
      sloganHeading.classList.remove('visible');

      if (newActiveIndex >= 0) {
        setTimeout(() => {
          sloganHeading.querySelector('h2').innerText = slogansArray[newActiveIndex];
          sloganHeading.classList.add('visible');
        }, 400);
      } else {
        sloganHeading.classList.remove('visible');
      }
    }

    /**
     * Sets listeners for 'scroll' event and recomputes the breakpoints on resize
     *
     * @returns {void}
     */
    function setListeners() {
      window.addEventListener('scroll', updateActiveSlogan);
      window.addEventListener('resize', () => {
        const newHeight = galleryContainer.getBoundingClientRect().height;
        breakpoints = computeBreakpoints(newHeight, slogansArray.length, 0.1, 0.83);
        updateActiveSlogan();
      });
    }

    /**
     * Initiates intersection observer to add transition effect to images
     *
     * @returns {void}
     */
    function initIntersectionObserverForImgs() {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('visible');
            } else {
              entry.target.classList.remove('visible');
            }
          });
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0.3,
        }
      );

      imageElements.forEach((img) => io.observe(img));
    }

    init();
  }
})();